exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pagination {\n  position: relative;\n  margin-top: 20px;\n}\n#pagination .pagination {\n  margin: 0;\n}\n#pagination .pagination .active > a, #pagination .pagination .active > a:hover, #pagination .pagination li > a:hover {\n  color: #fff;\n  background: #ec0000;\n  border: 1px solid transparent;\n}\n#pagination .pagination li a {\n  border-radius: 0 !important;\n  margin-right: 8px;\n  color: #7c7c7c;\n  border: 1px solid #ddd;\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n}\n#pagination .pagination .page-numbers {\n  border: 0;\n  color: #7c7c7c;\n  position: absolute;\n  right: 0;\n  top: 3px;\n}", ""]);

// exports
